import { getApi } from './api_instance'

export const fetchReportsTotalUsers = async (
  { duration = '', toDate = '', fromDate = '' ,page=1  ,  limit=10 },
  logout
)  => {
  try {
    const { data } = await getApi({
      apiUrl: `/admin/api/user/report?duration=${duration}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&limit=${limit}`,
      sendToken: true,
      logout
    })
    return data
  } catch (error) {
    throw error
  }
}


export const fetchAvailableCreditCount = async(
  { duration = '', toDate = '', fromDate = '' ,category="" ,registry="",location="",token_type="",page=1  ,  limit=10 },
  logout
) => {
  try {
    const { data } = await getApi({
      apiUrl: `/admin/projects/api/holdings/report/count?duration=${duration}&location=${location}&token_type=${token_type}&fromDate=${fromDate}&toDate=${toDate}&category=${category}&registry=${registry}&page=${page}&limit=${limit}`,
      sendToken: true,
      logout
    })
    return data
  } catch (error) {
    throw error
  }
}

export const fetchAvailableCreditValuation = async (
  { duration = '', toDate = '', fromDate = '' ,category="" ,registry="",location="",token_type="" ,page=1  ,  limit=10},
  logout
) => {
  try {
    const { data } = await getApi({
      apiUrl: `/admin/projects/api/holdings/report/valuation?duration=${duration}&location=${location}&token_type=${token_type}&fromDate=${fromDate}&toDate=${toDate}&category=${category}&registry=${registry}&page=${page}&limit=${limit}`,
      sendToken: true,
      logout
    })
    return data
  } catch (error) {
    throw error
  }
}

export const fetchReportPlatform = async (
  { duration = '', toDate = '', fromDate = '' ,page=1  ,  limit=10 },
  logout
) => {
  try {
    const { data } = await getApi({
      apiUrl: `/admin/payments/api/transactions/charges/report?duration=${duration}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&limit=${limit}`,
      sendToken: true,
      logout
    })
    return data
  } catch (error) {
    throw error
  }
}

export const fetchReportTransactions = async (
  {
    duration = '',
    toDate = '',
    fromDate = '',
    category = '',
    registry = '',
    location = '',
    token_type = '',page=1  ,  limit=10
  },
  logout
) => {
  try {
    const { data } = await getApi({
      apiUrl: `/admin/payments/api/transactions/value/report?duration=${duration}&location=${location}&token_type=${token_type}&fromDate=${fromDate}&toDate=${toDate}&category=${category}&registry=${registry}&page=${page}&limit=${limit}`,
      sendToken: true,
      logout
    })
    return data
  } catch (error) {
    throw error
  }
}
